var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from '@apollo/client';
import { Button, DialogActions, FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { SYSTEM_CONFIG_PROPERTY } from 'common/graphql/queries/system-config/system-config-property';
import CircularProgressMui from 'components/Loading/CircularProgresMui';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { activitySourceAdvisorDefaultConfig, } from './activity-source-advisor-config.const';
var ActivitySourceAdvisorDialog = function (_a) {
    var handleClose = _a.handleClose;
    var t = useTranslation().t;
    var _b = useQuery(SYSTEM_CONFIG_PROPERTY, {
        fetchPolicy: 'network-only',
        variables: {
            property: 'ACTIVITY_SOURCE_ADVISOR_CONFIG'
        }
    }), data = _b.data, sysLoading = _b.loading;
    var _c = useState(activitySourceAdvisorDefaultConfig), activitySourceAdvisorConfig = _c[0], setActivitySourceAdvisorConfig = _c[1];
    var _d = useState(activitySourceAdvisorConfig.questions.filter(function (q) { return q.id === activitySourceAdvisorConfig.firstQuestion; })[0]), firstQuestion = _d[0], setFirstQuestion = _d[1];
    var _e = useState(false), isComplete = _e[0], setIsComplete = _e[1];
    var _f = useState(false), isConfigError = _f[0], setIsConfigError = _f[1];
    var _g = useState(false), loading = _g[0], setLoading = _g[1];
    var _h = useState(firstQuestion), question = _h[0], setQuestion = _h[1];
    var _j = useState(0), variant = _j[0], setVariant = _j[1];
    var _k = useState([]), path = _k[0], setPath = _k[1];
    var _l = useState(undefined), finalPath = _l[0], setFinalPath = _l[1];
    var _m = useState(undefined), reply = _m[0], setReply = _m[1];
    useEffect(function () {
        if (data && data.systemConfigProperty.value) {
            setActivitySourceAdvisorConfig(JSON.parse(data.systemConfigProperty.value));
        }
    }, [data]);
    useEffect(function () {
        var firstQuestion = activitySourceAdvisorConfig.questions.filter(function (q) { return q.id === activitySourceAdvisorConfig.firstQuestion; })[0];
        setFirstQuestion(firstQuestion);
        setQuestion(firstQuestion);
    }, [activitySourceAdvisorConfig]);
    /**
     * Находит подхядящие пути.
     * Подходящий путь - тот, который совпадает начиная с первого элемента и вопросом и ответом.
     */
    var searchPaths = function (searchingPatternPath) {
        var suitablePaths = [];
        for (var _i = 0, _a = activitySourceAdvisorConfig.paths; _i < _a.length; _i++) {
            var path_1 = _a[_i];
            var pathPaths = path_1.paths;
            var _loop_1 = function (pathPath) {
                if (searchingPatternPath.every(function (el, index) { return pathPath[index] && el[0] === pathPath[index][0] && el[1] === pathPath[index][1]; })) {
                    suitablePaths.push(path_1.id);
                }
            };
            for (var _b = 0, pathPaths_1 = pathPaths; _b < pathPaths_1.length; _b++) {
                var pathPath = pathPaths_1[_b];
                _loop_1(pathPath);
            }
        }
        return suitablePaths;
    };
    /**
     * Находит следующий подходящий вопрос путём поиска по возможным совпадающим путям.
     * Берёт первый очередной уникальный совпадающий вопрос.
     */
    var getNextQuestionId = function () {
        if (path.length < 0)
            return -1;
        var suitablePaths = searchPaths(path);
        var suitablePathsPaths = [];
        var _loop_2 = function (pathId) {
            // console.log(pathId);
            for (var _a = 0, _b = activitySourceAdvisorConfig.paths.filter(function (path) { return path.id === pathId; })[0].paths; _a < _b.length; _a++) {
                var path_2 = _b[_a];
                suitablePathsPaths.push(path_2);
            }
        };
        for (var _i = 0, suitablePaths_1 = suitablePaths; _i < suitablePaths_1.length; _i++) {
            var pathId = suitablePaths_1[_i];
            _loop_2(pathId);
        }
        console.log(suitablePathsPaths);
        var uniqQuestionIds = _.uniq(suitablePathsPaths.map(function (suitablePath) {
            var _a;
            if (!((_a = suitablePath[path.length]) === null || _a === void 0 ? void 0 : _a.length))
                return -2;
            return suitablePath[path.length][0];
        }));
        console.log(uniqQuestionIds);
        return uniqQuestionIds[0];
    };
    useEffect(function () {
        if (path.length > 0) {
            var nextQuestionId_1 = getNextQuestionId();
            if (nextQuestionId_1 === -2) {
                setIsComplete(true);
                setLoading(true);
                setQuestion(undefined);
            }
            else if (nextQuestionId_1 === -1) {
                setIsConfigError(true);
                setQuestion(undefined);
            }
            else {
                setQuestion(activitySourceAdvisorConfig.questions.filter(function (q) { return q.id === nextQuestionId_1; })[0]);
                setVariant(0);
            }
        }
        setLoading(false);
    }, [path]);
    useEffect(function () {
        if (isComplete) {
            var suitablePaths_2 = searchPaths(path);
            console.log('Finally suitable PAths: ');
            console.log(suitablePaths_2);
            var finalPath_1 = activitySourceAdvisorConfig.paths.filter(function (path) { return path.id === suitablePaths_2[0]; })[0];
            setFinalPath(finalPath_1);
            var replyId_1 = finalPath_1 === null || finalPath_1 === void 0 ? void 0 : finalPath_1.reply;
            console.log(replyId_1);
            if (replyId_1 !== undefined) {
                setReply(activitySourceAdvisorConfig.replies.filter(function (reply) { return reply.id === replyId_1; })[0]);
            }
            setLoading(false);
        }
    }, [isComplete]);
    if (sysLoading)
        return _jsx(CircularProgressMui, {}, void 0);
    return (_jsxs("div", __assign({ className: "flex flex-col h-full" }, { children: [_jsxs("div", __assign({ className: "flex flex-col space-y-10 p-0 pb-20" }, { children: [_jsx("div", __assign({ className: "tw-dialog-header" }, { children: t('Помощник в выборе источника тренировок') }), void 0), isConfigError && (_jsx("p", __assign({ className: "text-red" }, { children: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043A\u043E\u0444\u043D\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438 \u043F\u043E\u043C\u043E\u0449\u043D\u0438\u043A\u0430, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0441\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0435 \u0432 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443" }), void 0)), isComplete && _jsx("p", __assign({ className: "text-green pb-5" }, { children: "\u0412\u044B \u043E\u0442\u0432\u0435\u0442\u0438\u043B\u0438 \u043D\u0430 \u0432\u0441\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B!" }), void 0), isComplete && finalPath && _jsx("p", __assign({ className: "dark:text-white font-semibold" }, { children: finalPath.description }), void 0), isComplete && reply && _jsx("p", __assign({ className: "dark:text-white" }, { children: reply.text }), void 0), isComplete && !reply && !loading && _jsx("p", __assign({ className: "text-red" }, { children: "\u041E\u0442\u0432\u0435\u0442 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D!" }), void 0), question && (_jsxs(_Fragment, { children: [_jsx("p", __assign({ className: "text-13 dark:text-white" }, { children: question.text }), void 0), _jsx(FormControl, { children: _jsx(RadioGroup, __assign({ className: "text-13 dark:text-white", value: variant, onChange: function (e) {
                                        setVariant(Number(e.target.value));
                                    } }, { children: question.variants.map(function (variant) {
                                        return (_jsx(FormControlLabel, { value: variant.id, control: _jsx(Radio, {}, void 0), label: variant.text }, void 0));
                                    }) }), void 0) }, void 0)] }, void 0))] }), void 0), _jsxs(DialogActions, __assign({ className: "flex justify-between p-0" }, { children: [_jsx(Button, __assign({ disabled: loading, onClick: function () {
                            if (question) {
                                setLoading(true);
                                setPath(function (previous) {
                                    var path = __spreadArray([], previous, true);
                                    path.push([question.id, variant]);
                                    return path;
                                });
                            }
                            else {
                                handleClose();
                            }
                        } }, { children: t(question ? 'Далее' : 'Отлично!') }), void 0), !question && (_jsx(Button, __assign({ variant: "text", onClick: function () {
                            setIsComplete(false);
                            setIsConfigError(false);
                            setQuestion(firstQuestion);
                            setVariant(0);
                            setPath([]);
                            setReply(undefined);
                            setLoading(false);
                        } }, { children: "\u041F\u0440\u043E\u0439\u0442\u0438 \u0435\u0449\u0451 \u0440\u0430\u0437" }), void 0))] }), void 0)] }), void 0));
};
export default ActivitySourceAdvisorDialog;
